import { useMutation } from '@apollo/client';
import useEnableFastifyApi from './useEnableFastifyApi';
import { CANCEL_FLIGHT } from '../mutations';
import restRequest from './restClient';
import useAsyncCall from './useAsyncCall';

// The GraphQL mutation returns a raw String, compared by callers against
// CANCEL_FLIGHT_RESPONSE_SUCCESSFUL ('CANCELLED') — the BFF's structured
// { status: 'CANCELLED' | 'FAILED', message? } response's `status` matches that exact value, so
// mapping to bffResponse.status keeps the existing comparison in CancellationModal working as-is.
function toGraphqlShape(bffResponse) {
  return { cancelFlight: bffResponse?.status };
}

export default function useCancelFlight(options) {
  const enableFastifyApi = useEnableFastifyApi();

  const graphqlResult = useMutation(CANCEL_FLIGHT, options);
  const [restExecute, restState] = useAsyncCall(
    ({ variables: { input } = {} } = {}) =>
      restRequest({
        method: 'POST',
        path: '/air-api/v1/flights/cancel',
        body: input,
      }).then(toGraphqlShape),
    options,
  );

  if (enableFastifyApi) {
    return [restExecute, restState];
  }
  return graphqlResult;
}
